<template>
  <el-dialog
    width="1200px"
    title="选择商品标签"
    :visible="visible"
    @close="close"
  >
    <div class="table-panel flex item-center flex-end">
      <el-input
        clearable
        style="width: 300px"
        v-model.trim="searchCondition.tagName"
        size="small"
        placeholder="请输入标签名"
        class="ipt mr10"
      >
        <!-- <el-select
          slot="prepend"
          size="small"
          style="width: 100px"
          @change="selectQueryType"
          v-model="searchCondition.queryType"
        >
          <el-option label="商品名" value="spu_name"></el-option>
          <el-option label="货号" value="goods_sn"></el-option>
          <el-option label="条码" value="spec_barcode"></el-option>
          <el-option label="品牌名" value="brand_name"></el-option>
        </el-select> -->
      </el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
    </div>
    <div class="table mb20">
      <el-table
        stripe
        border
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
        max-height="400"
      >
        <el-table-column
          type="selection"
          :selectable="selectEnable"
        ></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="tagName"
          label="标签名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="tagRemark"
          label="描述"
          header-align="center"
          align="center"
        ></el-table-column>
        <!-- <el-table-column
          prop="calcCount"
          label="覆盖人数"
          header-align="center"
          align="center"
        ></el-table-column> -->
        <el-table-column label="运行状态" header-align="center" align="center">
          <template v-slot="scope">
            <span class="success" v-if="scope.row.enabledState === 'yes'"
              >运行中</span
            >
            <span class="gray" v-else>未运行</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <span slot="footer" class="dialog-footer flex flex-center">
      <el-button size="small" type="primary" @click="saveGoods"
        >确 定</el-button
      >
      <el-button size="small" @click="close">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    },
    enabelList: {
      type: Array,
      default: () => []
    }
  },
  components: {},
  data() {
    return {
      searchCondition: {
        tagName: ""
      },
      total: 0,
      currentPage: 1,
      pageSize: 10,
      list: [],
      checkedRowList: [],
      placeholder: "请输入商品名",
      salesChannels: []
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    selectEnable(row) {
      if (this.enabelList.some(item => item.id === row.id)) {
        return false;
      } else {
        return true; // 不禁用
      }
    },
    // async querySalesChannels() {
    //   const { code, result } = await this.$store.dispatch("querySalesChannels");
    //   if (code === "0") {
    //     this.salesChannels = result;
    //   }
    // },
    saveGoods() {
      if (this.checkedRowList.length) {
        this.$emit("saveGoods", this.checkedRowList);
        this.$refs.multipleTable.clearSelection();
      } else {
        this.$message({
          message: "请选择商品",
          type: "warning"
        });
      }
    },
    selectQueryType(queryType) {
      if (queryType === "spuName") {
        this.placeholder = "请输入商品名";
      } else if (queryType === "goodsSn") {
        this.placeholder = "请输入货号";
      } else if (queryType === "specBarcode") {
        this.placeholder = "请输入条码";
      } else if (queryType === "brandName") {
        this.placeholder = "请输入品牌名";
      }
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // searchCondition.categoryId = this.isArray(searchCondition.categoryId)
      //   ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
      //   : searchCondition.categoryId;

      // searchCondition.attributeId = this.isArray(searchCondition.attributeId)
      //   ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
      //   : "";
      // if (searchCondition.platFormId === "isWxshop") {
      //   searchCondition.platFormId = "";
      //   searchCondition.isWxshop = "yes";
      // }
      Object.assign(params, searchCondition);

      const { code, result } = await this.$store.dispatch(
        "queryPhysiologicalTagList",
        params
      );
      if (code === "0") {
        const { records, total } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    handleSelectionChange(row) {
      this.checkedRowList = row;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    close() {
      this.$refs.multipleTable.clearSelection();
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped></style>
